import { render } from "./TempAlert.vue?vue&type=template&id=18a1515e"
import script from "./TempAlert.vue?vue&type=script&lang=js"
export * from "./TempAlert.vue?vue&type=script&lang=js"

import exportComponent from "/home/websites/repositories/macgear-scanner/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__